import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Fieldset } from "primereact/fieldset";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { Card } from "primereact/card";

const EquipmentForm = ({ formData, handleInputChange, parseDate, handleDateChange, options, tienePermiso }) => {

    const { signOptions, macOptions, modelOptions, capacityOptions } = options;

    const vinil = [
        { code: 1, name: 'SUMA' },
        { code: 2, name: 'SUMA TRAVEL' },
    ];

    const legendTemplate = (
        <div className="flex align-items-center justify-content-between w-full">
            <div>
                <h3 className="m-0 text-lg font-semibold text-color">Inventario, Equipamiento y DVR</h3>
                <p className="m-0 mt-1 text-sm text-color-secondary">Sistema de Gestión Vehicular</p>
            </div>
        </div>
    );

    return (
        <Fieldset legend={legendTemplate} toggleable className="mb-3 mt-3">
            <Card className="shadow-2" style={{ background: '#F4F6F9' }}>

                {/* Inventario */}
                <div className="form-section">

                    <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                        <i className="pi pi-box text-primary"></i>
                        <h3 className="m-0 text-lg font-semibold text-900">Inventario</h3>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col-12 md:col-6">
                            <label htmlFor="vinil" className="block">Vinil</label>
                            <Dropdown
                                id="vinil"
                                value={vinil?.find(name => name.code === formData?.VINIL)}
                                options={vinil}
                                optionLabel="name"
                                onChange={(e) => handleInputChange('VINIL', e.value.code)}
                                className="w-full"
                                placeholder="Seleccione..."
                                disabled={!tienePermiso}
                            />
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="trampaCombustible" className="block">Trampa Combustible</label>
                            <Calendar
                                id="trampaCombustible"
                                value={parseDate(formData?.COMBUSTIBLE_TRAMPA)}
                                onChange={handleDateChange('COMBUSTIBLE_TRAMPA')}
                                dateFormat="dd/mm/yy"
                                showIcon
                                locale="es"
                                className="w-full"
                                disabled={!tienePermiso}
                            />
                        </div>
                    </div>
                </div>

                {/* Equipamiento */}
                <div className="form-section">
                    <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                        <i className="pi pi-cog text-primary"></i>
                        <h3 className="m-0 text-lg font-semibold text-900">Equipamiento</h3>
                    </div>

                    <div className="formgrid grid">
                        {/* Checkboxes en grid compacto */}
                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="usb"
                                    checked={formData?.IE_USB}
                                    onChange={(e) => handleInputChange('IE_USB', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="usb" className="ml-2 mb-0">USB</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="asientosReclinables"
                                    checked={formData?.ASIENTO_RECLINA}
                                    onChange={(e) => handleInputChange('ASIENTO_RECLINA', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="asientosReclinables" className="ml-2 mb-0">Asientos Reclinables</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="cajuela"
                                    checked={formData?.IE_CAJUELA}
                                    onChange={(e) => handleInputChange('IE_CAJUELA', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="cajuela" className="ml-2 mb-0">Cajuela</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="camaraFatiga"
                                    checked={formData?.CAMARA_FATIGA}
                                    onChange={(e) => handleInputChange('CAMARA_FATIGA', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="camaraFatiga" className="ml-2 mb-0">Cámara de Fatiga</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="aforo"
                                    checked={formData?.IE_AFORO}
                                    onChange={(e) => handleInputChange('IE_AFORO', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="aforo" className="ml-2 mb-0">Aforo</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="portabultos"
                                    checked={formData?.IE_PORTABULTOS}
                                    onChange={(e) => handleInputChange('IE_PORTABULTOS', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="portabultos" className="ml-2 mb-0">Portabultos</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="desconeccionCamaras"
                                    checked={formData?.DESCONECTA_CAMARA}
                                    onChange={(e) => handleInputChange('DESCONECTA_CAMARA', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="desconeccionCamaras" className="ml-2 mb-0">Desconexión Cámaras</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="gps"
                                    checked={formData?.IE_GPS}
                                    onChange={(e) => handleInputChange('IE_GPS', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="gps" className="ml-2 mb-0">GPS</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="botonPanico"
                                    checked={formData?.BTN_PANICO}
                                    onChange={(e) => handleInputChange('BTN_PANICO', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="botonPanico" className="ml-2 mb-0">Botón de Pánico</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="sensorCamaras"
                                    checked={formData?.SENSOR_CAMARA}
                                    onChange={(e) => handleInputChange('SENSOR_CAMARA', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="sensorCamaras" className="ml-2 mb-0">Sensor de Cámaras</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="aireAcondicionado"
                                    checked={formData?.IE_AIRE}
                                    onChange={(e) => handleInputChange('IE_AIRE', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="aireAcondicionado" className="ml-2 mb-0">Aire Acondicionado</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="camaraReversa"
                                    checked={formData?.CAMARA_REVERSA}
                                    onChange={(e) => handleInputChange('CAMARA_REVERSA', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="camaraReversa" className="ml-2 mb-0">Cámara de Reversa</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center">
                                <Checkbox
                                    inputId="tv"
                                    checked={formData?.REQ_TV}
                                    onChange={(e) => handleInputChange('REQ_TV', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="tv" className="ml-2 mb-0">Requiere TV</label>
                            </div>
                        </div>

                        {/* Campos de input después de los checkboxes */}
                        <div className="field col-12 md:col-3">
                            <label htmlFor="cantidadTv" className="block">Cantidad de TVs</label>
                            <InputNumber
                                id="cantidadTv"
                                value={formData?.IE_TV}
                                onValueChange={(e) => handleInputChange('IE_TV', e.value)}
                                className="w-full"
                                min={0}
                                disabled={!tienePermiso}
                            />
                        </div>

                        <div className="field col-12 md:col-3">
                            <label htmlFor="letrero" className="block">Letrero</label>
                            <Dropdown
                                id="letrero"
                                value={signOptions?.find(sign => sign.code === formData?.LETRERO)}
                                options={signOptions}
                                optionLabel="name"
                                onChange={(e) => handleInputChange('LETRERO', e.value.code)}
                                className="w-full"
                                placeholder="Seleccione..."
                                disabled={!tienePermiso}
                            />
                        </div>
                    </div>
                </div>

                {/* DVR */}
                <div className="form-section">
                    <div className="flex align-items-center gap-2 mb-3 pb-2 border-bottom-1 surface-border">
                        <i className="pi pi-video text-primary"></i>
                        <h3 className="m-0 text-lg font-semibold text-900">DVR (Sistema de Video Digital)</h3>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col-12 md:col-3">
                            <div className="flex align-items-center" style={{ height: '100%' }}>
                                <Checkbox
                                    inputId="reqDvr"
                                    checked={formData?.REQ_DVR}
                                    onChange={(e) => handleInputChange('REQ_DVR', e.checked)}
                                    disabled={!tienePermiso}
                                />
                                <label htmlFor="reqDvr" className="ml-2 mb-0 font-semibold">Requiere DVR</label>
                            </div>
                        </div>

                        <div className="field col-12 md:col-3">
                            <label htmlFor="macAddress" className="block">MAC Address</label>
                            <Dropdown
                                id="macAddress"
                                value={macOptions?.find(mac => mac.code === formData?.ID_EQUIPOS_MOVILES_MAC)}
                                options={macOptions}
                                optionLabel="name"
                                onChange={(e) => handleInputChange('ID_EQUIPOS_MOVILES_MAC', e.value.code)}
                                filter
                                className="w-full"
                                placeholder="Seleccione..."
                                disabled={!formData?.REQ_DVR || !tienePermiso}
                            />
                        </div>

                        <div className="field col-12 md:col-2">
                            <label htmlFor="modeloDvr" className="block">Modelo</label>
                            <Dropdown
                                id="modeloDvr"
                                value={modelOptions?.find(model => model.code === formData?.IE_DVR_MODELO)}
                                options={modelOptions}
                                optionLabel="name"
                                onChange={(e) => handleInputChange('IE_DVR_MODELO', e.value.code)}
                                className="w-full"
                                placeholder="Seleccione..."
                                disabled={!formData?.REQ_DVR || !tienePermiso}
                            />
                        </div>

                        <div className="field col-12 md:col-2">
                            <label htmlFor="capacidadDvr" className="block">Capacidad</label>
                            <Dropdown
                                id="capacidadDvr"
                                value={capacityOptions?.find(cap => cap.code === formData?.IE_DVR_CAPACIDAD)}
                                options={capacityOptions}
                                optionLabel="name"
                                onChange={(e) => handleInputChange('IE_DVR_CAPACIDAD', e.value.code)}
                                className="w-full"
                                placeholder="Seleccione..."
                                disabled={!formData?.REQ_DVR || !tienePermiso}
                            />
                        </div>

                        <div className="field col-12 md:col-2">
                            <label htmlFor="cantidadCamaras" className="block">Cant. Cámaras</label>
                            <InputNumber
                                id="cantidadCamaras"
                                value={formData?.IE_DVR_CAMARA_CANT}
                                onValueChange={(e) => handleInputChange('IE_DVR_CAMARA_CANT', e.value)}
                                className="w-full"
                                min={0}
                                disabled={!formData?.REQ_DVR || !tienePermiso}
                            />
                        </div>
                    </div>
                </div>

            </Card>
        </Fieldset>
    );
};

export default EquipmentForm;
